export default {
    peronInfoTitle: "Complete your profile so recruiters can quickly learn more about you",
    skip: "Skip",
    pleaseEnter: "Please enter",
    pleaseSelect: "Please select",
    continue: "Continue",
    name: "Full name",
    namePlaceholder: "Please enter your full name ",
    gender: "Gender",
    male: "Male",
    female: "Female",
    dateOfBirth: "Date of birth",
    startWorkingDate: "Start working date",
    jobStatus: "Job search status",
    personInfoCommitWarring: "Please complete your personal information",
    jobIntentionTitle: "Complete your job preferences to highlight your resume and increase your chances of getting hired",
    jobType: "Preferred job type",
    preferredPosition: "Preferred position",
    preferredCity: "Preferred city",
    preferredSalary: "Expected salary",
    jobIntentionCommitWarring: "Please complete your job preferences",
    educationTitle: "Complete education info to attract top recruiters",
    school: "School",
    highestDegree: "Highest degree",
    major: "Major",
    studyPeriod: "Study period",
    timeWarring: "Start date must be before end date",
    educationCommitWarring: "Please complete your education information",
    step1: "Step 1",
    step2: "Step 2",
    step3: "Step 3",
    save: "Save",
    saveAndContinue: "Save and continue",
    savedSuccessfully: "Saved successfully",
    startTime: "Enrollment date",
    endTime: "Graduation date",
    schoolName: "School Name",
    cityNotFound: "City not found",
    enterStartTime: "Please enter enrollment date",
    enterEndTime: "Please enter graduation date",
    notAllowEmoji: "Emojis are not allowed",
};
